export const RegistrationStep = Object.freeze({
    General: '-step-one',
    PersonalDetails: '-step-two',
    CustomerLocation: '-step-three'
});